// extracted by mini-css-extract-plugin
export default {"containertechInfo":"technical-info_containertechInfo__UBntE"};